import React from 'react';
import { useQuickFillPageConnectorController } from '../hooks/useQuickFillPageConnectorController';
import { useQuickFillPageWorkspaceController } from '../hooks/useQuickFillPageWorkspaceController';
import { useQuickFillPageInteractionController } from '../hooks/useQuickFillPageInteractionController';
import { useQuickFillPageExperienceController } from '../hooks/useQuickFillPageExperienceController';
import { useQuickFillPageValidationController } from '../hooks/useQuickFillPageValidationController';
import QuickFillPageView from './QuickFillPageView';
import type { QuickFillPageProps } from './quickFillPageTypes';

export type { EmbeddedQuickFillActions } from './quickFillPageTypes';

const QuickFillPage: React.FC<QuickFillPageProps> = ({
  onGoBack,
  onContinue,
  embedded = false,
  registerEmbeddedActions,
  footerActionsRef,
}) => {
  const connector = useQuickFillPageConnectorController(footerActionsRef);
  const workspace = useQuickFillPageWorkspaceController(connector, onContinue);
  const interactions = useQuickFillPageInteractionController(workspace);
  const experience = useQuickFillPageExperienceController(
    interactions,
    embedded,
    registerEmbeddedActions
  );
  const controller = useQuickFillPageValidationController(experience, onGoBack);

  return (
    <QuickFillPageView
      controller={controller}
      onGoBack={onGoBack}
      onContinue={onContinue}
      embedded={embedded}
    />
  );
};

export default QuickFillPage;
